import { render, staticRenderFns } from "./insurer-plan-commission.vue?vue&type=template&id=7465169f&scoped=true&"
import script from "./insurer-plan-commission.vue?vue&type=script&lang=js&"
export * from "./insurer-plan-commission.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan-commission.vue?vue&type=style&index=0&id=7465169f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7465169f",
  null
  
)

export default component.exports